module.exports = __webpack_public_path__ + "img/268-d96aca.png";